import * as React from 'react';
// Bootstrap
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import ListGroup from 'react-bootstrap/ListGroup';
//@ts-ignore
//!!r-18-dj
import { Link, useHistory } from 'react-router-dom'
import NewClientModal from '../../components/it_operations/client_management/NewClientModal';
import IconButton from '../../components/common/IconButton';
import axios from 'axios';
import AxiosConfig from '../../utilities/AxiosConfig';
import ErrorAlert from '../../components/common/ErrorAlert';
import Loader from '../../components/common/Loader';
import ClipboardIcon from '../../components/common/ClipboardIcon';
import logger from '../../utilities/logging';
import { createOptionsList, useQuery } from '../../utilities/helper';

export type ClientItem = {
    PortalClientId : string,
    Secret : string | null,
    Description : string | null,
    TokenLifetimeSeconds : number | null,
    AllowedOrigin : string,
    ActivationPassword : string | null,
    CreatedDate : Date | null,
    CreatedBy : string | null,
    ModifyDate : Date | null,
    ModifiedBy : string | null,
    DeletedDate : Date | null,
    DeletedBy : string | null,
    DisabledDate : Date | null,
    DisabledBy : string | null,
    DisabledMessage : string | null,
    MaxRequestsSecond : number,
    MaxRequestsMinute : number,
    MaxRequestsHour : number,
    MaxRequestsDay : number,
    MaxRequestsWeek : number,
    FailedAuthLockoutThreshold : number,
    FailedAuthLockoutPeriodMins : number,
    CustomerId : number | null
}

const ClientManagement: React.FC = () => {
    const [loading, setLoading] = React.useState(false);
    const [originalList, setOriginalList] = React.useState([]);
    const [data, setData] = React.useState([]);
    const [error, setError] = React.useState("");
    const [highlightedClient, setHighlightedClient] = React.useState("");
    const [customerIds, setCustomerIds] = React.useState([]);
    const history = useHistory();
    let query = useQuery();

    React.useEffect(() => {
        getRegisteredClients();
    }, [])

    const getRegisteredClients = () => {
        setLoading(true);
        axios.get(process.env.REACT_APP_API_URL + "/api/portal/client/*", AxiosConfig.configValue())
        .then(response => {
            const { data } = response;
            setOriginalList(data.clients);
            setData(data.clients);
            let c:any = createOptionsList(data.reference);
            setCustomerIds(c);
            //console.log("Get Registered Clients", response, response.data);
        })
        .catch(error => {
            setError("There was a problem getting registered clients");
            //console.log(error);
            logger.Error({
                EventMessage : "ClientManagement.tsx -> getRegisteredClients -> Error :" + JSON.stringify(error.response),
                EventCategory : "httpresponse"
            });
            AxiosConfig.handleError(error);
        })
        .finally(() => {
            setLoading(false);
        })
    }

    const addClientCallback = (newClient: ClientItem) => {
        let copy:any = [...data];
        copy.push(newClient);
        setData(copy);
        setHighlightedClient(newClient.PortalClientId);
        if(newClient.PortalClientId){
            history.push("/it/client-management/" + newClient.PortalClientId);
        }
        setTimeout(() => {
            setHighlightedClient("");
        }, 2000)
    }

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        let c = [...originalList]
        const f = c.filter((item: any) => {
            if(item.PortalClientId.toUpperCase().includes(e.target.value.toUpperCase())){
                return item;
            }
            return false;
        });
        setData(f);
    }

    const showingText = (count: number):string => count ? count > 1 ? "Results" : "Result" :"No Results";

    return(
        <Col sm>
            <Container fluid className="h-100 no-vertical" style={{ maxHeight : "calc(100vh - 48px)", overflowY : "scroll" }}>
                <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
                    <h4 className="d-flex flex-column flex-md-row">Client Management <span className="p">(Showing {data.length > 0&&data.length} {showingText(data.length)})</span></h4>
                    <input disabled={loading} onChange={handleSearchChange} className="form-control w-50" type="search" placeholder="Search Clients" />
                    <IconButton disabled={loading} onClick={() => history.push("/it/client-management?open=true")} buttonClassName="btn-primary" icon="add">Add Client</IconButton>
                </div>
                <ErrorAlert show={error.length > 0}>
                    {error}&nbsp;Would you like to <span className="action-icon cursor-on-hover" onClick={getRegisteredClients} >Try again?</span>
                </ErrorAlert>
                <ListGroup variant="flush" className="mb-4">
                    {
                        loading
                        ?
                        <div className="d-flex justify-content-center align-items-center" style={{ maxHeight : "1000px", minHeight : "300px" }}>
                            <Loader classNames="mt-3" title="Loading Clients" />
                        </div>
                        :
                        data.map((value: any) => (
                            <ListGroup.Item className={`d-flex align-items-center ${highlightedClient === value.PortalClientId&&"border border-primary"}`} action as={Link} to={`/it/client-management/${value.PortalClientId}`} key={value.PortalClientId}>
                                {(value.DisabledBy && value.DisabledDate)
                                    ?<i className="material-icons text-secondary">cancel</i>
                                    :<i className="material-icons text-success">check_circle</i>
                                }
                                <span className="mx-2">{`${value.PortalClientId} (${value.Description})`}</span>
                                {value.Secret&&
                                <><span data-private="redact" className="ml-auto d-none d-md-block">{value.Secret}</span><ClipboardIcon text={value.Secret}/></>
                                }
                            </ListGroup.Item>
                        ))
                    }
                </ListGroup>
            </Container>
            {/*r-18-dj*/}
            {/*@ts-ignore*/}
            <NewClientModal customerIds={customerIds} clients={data.map((item: ClientItem) => item.PortalClientId)} afterSave={addClientCallback} onHide={() => history.push("/it/client-management")} show={query.get("open")} />
        </Col>
    )
}

export default ClientManagement;